import common from './common';

const homeDomain = 'customer.qa.xfinity.com';
const mobileDomain = 'mcx-staging.dss-ops.xfinity.com/mobile';
const paymentDomain = 'payments.qa.xfinity.com';

const CONFIG = {
  ...common,
  homeDomain,
  mobileDomain,
  billServicesUrl: `https://${homeDomain}/billing/services`,
  billingUrl: `https://${homeDomain}/#/billing`,
  billingMobileUrl: `https://${homeDomain}/billing/mobile`,
  billingMobileTransactionsUrl: `https://${homeDomain}/billing/mobile/transactions`,
  makePaymentUrl: `https://${paymentDomain}/new`,
  cwaRoot: 'https://staging-static.cimcontent.net/common-web-assets/',
  // Where to go if no continueUrl specified (from consent flow)
  paymentSetupDefaultContinue: `https://${homeDomain}/`,
  featureFlagEndpoint: 'https://sdx.qa.xfinity.com/cms/data/myAccount/web/staging/featureFlagsStaging.json',
  shelbyCMSUrl: 'https://sdx.qa.xfinity.com/cms/data/',
  collectionsBack: 'https://www.stg.xfinity.com/buy/plan/xap',
  oauthUrl: 'https://oauth-st.xfinity.com',
  nowMobileUrl: `https://${mobileDomain}/my-account/now/activity`,
  xmMyAccountUrl: `https://${mobileDomain}/my-account`,
  devicesMobileUrl: `https://${mobileDomain}/my-account/devices`,
  cottonClientId: 'dss-mw-pci-qa',
  firebaseEnabled: true,
  firebaseConfig: {
    ...common.firebaseConfig,
    appId: '1:583702985741:web:18aad49fdc6f9f2807a944',
    measurementId: 'G-Y9QJV76JPE',
  },
};

export default CONFIG;
